import React, { useEffect } from "react";
import Link from "next/link";
import classNames from "classnames";
import Style from "./styles.module.scss";
import Image from "next/image";
import axios from "axios";
import { PostsProps, PressProps } from "./types";
const InPress = () => {
  const [pressPosts, setPressPosts] = React.useState<Array<PostsProps>>([]);
const [hubtpotPressFields, setHubtpotPressFields] = React.useState<PressProps>();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get("/api/press/common-press");
        setPressPosts(data);
      } catch (e) {}
    };
    fetchData().catch(console.error);
  }, []);

  useEffect(() => {
    const fetchHubSpotPromotionBanner = async () => {
      try {
        const { data } = await axios.get("/api/hubspot-cms/press-cms"); // Ensure this matches your API route
        console.log("HubSpot banner data:", data);
        setHubtpotPressFields(data.fieldPlaceholders);
      } catch (error) {
        if (axios.isAxiosError(error)) {
          console.error("Error fetching HubSpot banner:", error.message);
        } else {
          console.error("Error fetching HubSpot banner:", error);
        }
      }

    };
   
    fetchHubSpotPromotionBanner();
  }, []);

  return (
    <div className="container py-30 bg-white">
      <div className="font-bold-h4 mb-10">{hubtpotPressFields?.title}</div>
      <div className={Style.cardsWrapper}>
        {pressPosts &&
          pressPosts.map((item) => (
            <div className={classNames(Style.cardContainer)} key={item?.id}>
              <div className={Style.cardLeft}>
                <div className={classNames("py-3", Style.cardHeader)}>
                  <div className={classNames("font-regular-sm", Style.dateWrapper)}>
                    {item?.date}
                  </div>
                </div>
                <div className="font-bold-base mt-10 link">
                  <Link href={item?.link}>
                    <a className={classNames(Style.textPrimary)}>
                      {item?.title}
                    </a>
                  </Link>
                </div>
              </div>
              <div className={Style.cardRight}>
                <div className={Style.imgWrapper}>
                  <Image
                    unoptimized
                    src={item?.image}
                    alt="pressPost-logo"
                    layout="fill"
                    objectFit="contain"
                  />
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
export default InPress;
